import { shape, string } from 'prop-types';

const customer = shape({
  abandonEmail: string.isRequired,
  additionalAddress: string,
  additionalPhone: string.isRequired,
  additionalPhoneDialCode: string,
  city: string.isRequired,
  customerCountry: string.isRequired,
  email: string.isRequired,
  firstName: string.isRequired,
  floor: string,
  lastName: string.isRequired,
  phone: string.isRequired,
  phoneNumber: string.isRequired,
  phoneCode: string.isRequired,
  phoneDialCode: string.isRequired,
  street: string.isRequired,
  streetNumber: string.isRequired,
  title: string,
  zipCode: string.isRequired,
});

export { customer as default };
